import React, { useState } from "react";
import { Modal, Box, Typography, Button, Checkbox, FormControlLabel, Icon, ThemeProvider } from "@mui/material";
import { Document, Page } from "react-pdf";
import { lgpdBase64 } from "../assets/LGPD";
import AgreementModalRoot from "./AgreementModal.styles";
import { createTheme, alpha, getContrastRatio } from '@mui/material/styles';
import { fontSize } from "@mui/system";

declare module '@mui/material/styles' {
  interface Palette {
    violet: Palette['primary'];
  }

  interface PaletteOptions {
    violet?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    violet: true;
  }
}

const violetBase = '#7F00FF';
const violetMain = "#FFF";

const theme = createTheme({
  palette: {
    violet: {
      main: violetMain,
      light: alpha(violetBase, 0.5),
      dark: alpha(violetBase, 0.9),
      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',
    },
  },
});

const AgreementModal = ({
    open,
    handleClose,
    onAgree,
}: {
    open: boolean;
    handleClose: () => void;
    onAgree: () => void;
}) => {
    const [accepted, setAccepted] = useState(false);

    return (
        <AgreementModalRoot>
            <Modal open={open} onClose={handleClose} aria-labelledby="agreement-title">
                <>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: window.innerWidth  < 500 ? 330 : 600 ,
                            height: 600,
                            overflowY: "scroll",
                            overflowX: 'hidden',
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            paddingTop: 0,
                            paddingBottom: 2,
                            paddingLeft: 2,
                            paddingRight: 2,
                            //p: 4,
                            borderRadius: 2,

                            "&::-webkit-scrollbar": {
                                width: 8
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#ffffff"
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "#6b00a1"
                            }
                        }}
                    >
                        <Button sx={{  color: 'white', fontSize: '2rem' }} onClick={handleClose}>x</Button>
                        <>
                            <Document file={`data:application/pdf;base64,${lgpdBase64}`} renderMode="canvas">
                                {Array.from(new Array(4), (_el, index) => (
                                    <>
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            width={window.innerWidth  < 500 ? 330 : 560 }
                                            renderAnnotationLayer={false}
                                            renderTextLayer={false}
                                        />
                                        <div style={{ height: 5 }} />
                                        {/* <Typography sx={{
                                            textAlign: 'end',
                                            color: 'white',
                                            marginRight: '1rem',
                                        }} >{index + 1}</Typography> */}
                                    </>
                                ))}
                            </Document>
                        </>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                    color="primary"
                                />
                            }
                            sx={{
                                color:'white',
                                fontSize:'1rem'
                            }}
                            label="Eu aceito os termos e condições"
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 2}}>
                            <ThemeProvider theme={theme}>
                                <Button onClick={handleClose} color="violet" style={{ textTransform: "none" }}>
                                    Cancelar
                                </Button>
                            </ThemeProvider>
                            <Button
                                onClick={onAgree}
                                color="primary"
                                variant="contained"
                                sx={{ ml: 2 }}
                                disabled={!accepted}
                            >
                                Concordar e Continuar
                            </Button>
                        </Box>
                    </Box>
                </>
            </Modal>
        </AgreementModalRoot>
    );
};

export default AgreementModal;
